import React from 'react'
import { useTranslation } from 'react-i18next'

import Select, { components } from 'react-select'
import styles from 'components/global/CUK/AsyncSelect/styles'
import { OptionMultiCount } from 'components/global/CUK/AsyncSelect/components/Option'
import { ClickAwayListener, Typography, useTheme } from '@mui/material'
import { Box } from '@mui/system'
import StateIcon from 'components/global/StateIcon'

const Control = ({children, ...props}) => {
  const { menuIsOpen, onMenuClose, onMenuOpen } = props.selectProps
  return (
    <components.Control {...props}>
      <ClickAwayListener
        mouseEvent="onMouseDown"
        onClickAway={() => {
          onMenuClose()
        }}>
        <Box
          onClick={() => {
            if (menuIsOpen) {
              onMenuClose()
            } else {
              onMenuOpen()
            }
          }}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexGrow: 1,
            gap: 7,
            cursor: 'pointer'
          }}>
          {children}
        </Box>
      </ClickAwayListener>
    </components.Control>
  )
}
const MenuList = ({ children, ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <components.MenuList {...props}>
      {children}
      <Box
        ml={1}
        mt={1}
        color={'grey.600'}
        fontSize={12}
        fontWeight={500}
        onClick={() => props.setValue([])}
        sx={{
          cursor: 'pointer',
          '&:hover': {
            color: theme.palette.grey[800]
          }
        }}>
        {t('actions.deselect_all')}
      </Box>
    </components.MenuList>
  )
}
const DropdownIndicator = ({ ...props }) => {
  const theme = useTheme()
  return (
    <Box mr={1}>
      {props.selectProps.menuIsOpen ? (
        <StateIcon iconlabel={'angle-up'} iconweight={'regular'} iconcolor={theme.palette.primary.main} />
      ) : (
        <StateIcon iconweight={'regular'} iconlabel={'angle-down'} />
      )}
    </Box>
  )
}

const ValueContainer = ({ ...props }) => {
  const theme = useTheme()
  const selectedValuesCount = props.getValue().length

  return (
    <components.ValueContainer {...props}>
      <Box>
        <Typography
          sx={{
            color: '#464646',
            fontSize: '12px',
            paddingLeft: theme.spacing(1.5),
            fontWeight: 400,
          }}
        >
          {selectedValuesCount === 0
            ? props.selectProps.placeholder
            : `${selectedValuesCount} sélectionnés`}
        </Typography>
      </Box>
    </components.ValueContainer>
  )
}

const Option = (props) => {
  return (
    <OptionMultiCount
      {...props}
      value={props.data}
      count={props.data.count}
      availability={props.data.value}
    />
  )
}

const FilterSelectMulti = ({
  options,
  onChange,
  values = [],
  placeholder = 'Search',
  width = null
}) => {
  const theme = useTheme()
  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      options={options}
      onChange={(values) => {
        onChange(values.map(({ value }) => value))
      }}
      mainField="label"
      placeholder={placeholder}
      components={{
        ...components,
        Option,
        Control: ({ children, ...props }) => <Control {...props}>{children}</Control>,
        MenuList: ({ children, ...props }) => <MenuList {...props}>{children}</MenuList>,
        DropdownIndicator,
        ValueContainer,
        Placeholder: (props) => <Box><components.Placeholder {...props} /></Box>,
        IndicatorSeparator: null,
        ClearIndicator: null,
      }}
      value={options.filter(
        (choice) => values.findIndex((value) => choice.value === value) > -1,
      )}
      styles={styles({theme, width})}
    />
  )
}

export default FilterSelectMulti
